// extracted by mini-css-extract-plugin
export default {"emptyContent":"EmptyList_emptyContent__5B48C","emptyText":"EmptyList_emptyText__SUpLl","emptyIcon":"EmptyList_emptyIcon__4MH4k"};